import React from "react";
import Loader from "../../Helper/Loader";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Box,
} from "@mui/material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";

export default function ChangeNamePopup({
  setOpenRenameQuestionBankNamePopup,
  questionBankRenameData,
  setQuestionBankRenameData,
  handleRenameQuestionBankName,
  isProcessLoading,
}) {
  return (
    <Dialog
      open={true}
      onClose={() => setOpenRenameQuestionBankNamePopup(false)}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: "8px",
        },
      }}
    >
      {isProcessLoading ? (
        <DialogContent sx={{ textAlign: "center", py: 4 }}>
          <Loader />
        </DialogContent>
      ) : (
        <>
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              fontWeight: 700,
              color: "#111827",
              pb: 1,
            }}
          >
            <Box
              sx={{
                backgroundColor: "#FFF7ED",
                color: "#F28C28",
                borderRadius: "50%",
                padding: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <DriveFileRenameOutlineIcon fontSize="small" />
            </Box>
            Rename Question Bank
          </DialogTitle>

          <DialogContent>
            <Typography variant="body2" sx={{ color: "#6B7280", mb: 2 }}>
              Enter a new name for your question bank.
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Question Bank Name"
              value={questionBankRenameData.questionBankName}
              onChange={(e) =>
                setQuestionBankRenameData((prev) => ({
                  ...prev,
                  questionBankName: e.target.value,
                }))
              }
              inputProps={{ maxLength: 250 }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  backgroundColor: "#F9FAFB",
                  "& fieldset": { borderColor: "#D1D5DB" },
                  "&:hover fieldset": { borderColor: "#F28C28" },
                  "&.Mui-focused fieldset": { borderColor: "#F28C28" },
                },
              }}
            />
          </DialogContent>

          <DialogActions sx={{ padding: "16px 24px 24px 24px", gap: 1 }}>
            <Button
              onClick={() => setOpenRenameQuestionBankNamePopup(false)}
              variant="outlined"
              sx={{
                color: "#4B5563",
                borderColor: "#D1D5DB",
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "#F9FAFB",
                  borderColor: "#9CA3AF",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() =>
                handleRenameQuestionBankName(
                  questionBankRenameData.questionBankId,
                )
              }
              variant="contained"
              sx={{
                backgroundColor: "#F28C28",
                color: "#fff",
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 600,
                boxShadow: "0 4px 6px rgba(242, 140, 40, 0.2)",
                "&:hover": {
                  backgroundColor: "#E07C24",
                  boxShadow: "0 6px 8px rgba(242, 140, 40, 0.3)",
                },
              }}
            >
              Save
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}
